import React from 'react';
import { FieldWrapper } from '@progress/kendo-react-form';
import { Error, Hint, Label } from '@progress/kendo-react-labels';
import { RenderTypes } from '../../../../constants/applicationConstants';

/**
 * File Upload Component
 * @type {React.FC<Props>}
 * @returns {React.ReactElement}
 */
export const FileUpload = (fieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    optional,
    required,
    readOnly,
    value,
    renderTypes,
    fieldWrapperStyles,
    requiredField,
    onChange,
    ...others
  } = fieldRenderProps;

  // Create a ref to the file input element
  const fileInputRef = React.useRef(null);

  const showValidationMessage = touched && validationMessage;
  const showHint = !showValidationMessage && hint;
  const hintId = showHint ? `${id}_hint` : '';
  const errorId = showValidationMessage ? `${id}_error` : '';

  return (
    <FieldWrapper>
      {label && (
        <span className='k-floating-label-container k-label'>
          <Label
            editorId={id}
            editorValid={valid}
            editorDisabled={disabled}
            optional={optional}
          >
            {label} {requiredField && <span className='required-field'>*</span>}
          </Label>
        </span>
      )}
      {renderTypes === RenderTypes.ReadOnly ? (
        <span className='display-text'>
          {value ? value.name : 'No file chosen'}
        </span>
      ) : (
        <div className={'k-form-field-wrap'} style={fieldWrapperStyles}>
          <input
            type='file'
            className='k-input k-input-md k-rounded-md k-input-solid'
            id={id}
            onChange={onChange} // Use the onChange handler from props
            disabled={disabled}
            required={required}
            ref={fileInputRef}
            {...others}
          />
          {showHint && <Hint id={hintId}>{hint}</Hint>}
          {showValidationMessage && (
            <Error id={errorId}>{validationMessage}</Error>
          )}
        </div>
      )}
    </FieldWrapper>
  );
};

export default FileUpload;
